module.exports = __webpack_public_path__ + "static/media/es.1f23da73.svg";